<template>
  <!-- Formulario -->
  <v-form ref="form" autocomplete="off">
    <v-row>
      <!-- Descripción -->
      <v-col cols="12" sm="12" md="12">
        <v-text-field
          v-model="editedItem.Descripcion"
          label="Descripción:"
          clearable
          dense
          maxlength="100"
          counter="100"
          hint="Digite Información"
          :rules="[rules.required]"
        >
        </v-text-field>
      </v-col>

      <!-- Tipo Disparador -->
      <v-col cols="12" sm="12" md="12">
        <v-autocomplete
          v-model="editedItem.Tipo"
          :items="ArrayTipoDisparador"
          :item-title="
            (ArrayTipoDisparador) =>
              ArrayTipoDisparador.Valor + '-' + ArrayTipoDisparador.Descripcion
          "
          item-value="Valor"
          label="Tipo Disparador:"
          dense
          clearable
          :rules="[rules.required]"
          @update:modelValue="ChangeTipoDisparador()"
        >
        </v-autocomplete>
      </v-col>

      <!-- Pagina -->
      <v-col v-if="editedItem.Tipo == TipoDisparador.Pagina" cols="12" sm="12" md="12">
        <v-text-field
          v-model="editedItem.Pagina"
          label="Página:"
          clearable
          dense
          maxlength="100"
          counter="100"
          hint="Digite Información"
          :rules="editedItem.Tipo == TipoDisparador.Pagina ? [rules.required] : []"
        >
        </v-text-field>
      </v-col>

      <!-- Subrutina -->
      <v-col v-if="editedItem.Tipo == TipoDisparador.Subrutina" cols="12" sm="12" md="12">
        <v-text-field
          v-model="editedItem.Subrutina"
          label="Subrutina:"
          clearable
          dense
          type="tel"
          v-on:keypress="isNumber()"
          maxlength="9"
          counter="9"
          :rules="editedItem.Tipo == TipoDisparador.Subrutina ? [rules.required] : []"
        >
        </v-text-field>
      </v-col>

      <!-- Evento -->
      <v-col v-if="editedItem.Tipo == TipoDisparador.Evento" cols="12" sm="6" md="6">
        <v-text-field
          v-model="editedItem.Evento"
          label="Evento:"
          clearable
          dense
          maxlength="20"
          counter="20"
          hint="Digite Información"
          :rules="editedItem.Tipo == TipoDisparador.Evento ? [rules.required] : []"
        >
        </v-text-field>
      </v-col>

      <!-- Nombre Evento -->
      <v-col v-if="editedItem.Tipo == TipoDisparador.Evento" cols="12" sm="6" md="6">
        <v-text-field
          v-model="editedItem.NombreEvento"
          label="Nombre Evento"
          clearable
          dense
          maxlength="100"
          counter="100"
          hint="Digite Información"
          :rules="editedItem.Tipo == TipoDisparador.Evento ? [rules.required] : []"
        >
        </v-text-field>
      </v-col>

      <!-- Creación -->
      <v-col cols="12" sm="3" md="3">
        <v-switch
          v-model="editedItem.Creacion"
          color="red-darken-3"
          label="Creación"
          hide-details
          inset
        ></v-switch>
      </v-col>

      <!-- Modificación -->
      <v-col cols="12" sm="3" md="3">
        <v-switch
          v-model="editedItem.Modificacion"
          color="red-darken-3"
          label="Modificación"
          hide-details
          inset
        ></v-switch>
      </v-col>

      <!-- Consulta -->
      <v-col cols="12" sm="3" md="3">
        <v-switch
          v-model="editedItem.Consulta"
          color="red-darken-3"
          label="Consulta"
          hide-details
          inset
        ></v-switch>
      </v-col>

      <!-- Retiro -->
      <v-col cols="12" sm="3" md="3">
        <v-switch
          v-model="editedItem.Retiro"
          color="red-darken-3"
          label="Eliminación"
          hide-details
          inset
        ></v-switch>
      </v-col>

      <!-- Asignacion -->
      <v-col cols="12" sm="3" md="3">
        <v-switch
          v-model="editedItem.Asignacion"
          color="red-darken-3"
          label="Asignación"
          hide-details
          inset
        ></v-switch>
      </v-col>

      <!-- Proceso de Entrada -->
      <v-col cols="12" sm="3" md="3">
        <v-switch
          v-model="editedItem.ProcesoEntrada"
          color="red-darken-3"
          label="Proceso de Entrada"
          hide-details
          inset
        ></v-switch>
      </v-col>

      <!-- Proceso de Salida -->
      <v-col cols="12" sm="3" md="3">
        <v-switch
          v-model="editedItem.ProcesoSalida"
          color="red-darken-3"
          label="Proceso de Salida"
          hide-details
          inset
        ></v-switch>
      </v-col>

      <!--Graba Actualiza Dato -->
      <v-col cols="12" sm="3" md="3">
        <v-switch
          v-model="editedItem.GrabaActualizaDato"
          color="red-darken-3"
          label="Graba Actualiza Dato"
          hide-details
          inset
        ></v-switch>
      </v-col>

      <!-- Procesos -->
      <v-col
        v-if="editedItem.ProcesoEntrada || editedItem.ProcesoSalida"
        cols="12"
        sm="4"
        md="4"
      >
        <v-autocomplete
          v-model="editedItem.ProcesoId"
          :items="ArrayProcesos"
          :item-title="
            (ArrayProcesos) => ArrayProcesos.ProcesoId + '-' + ArrayProcesos.Descripcion
          "
          item-value="ProcesoId"
          label="Proceso:"
          dense
          :rules="
            editedItem.ProcesoEntrada || editedItem.ProcesoSalida ? [rules.required] : []
          "
        >
        </v-autocomplete>
      </v-col>

      <!-- Datos -->
      <v-col
        v-if="editedItem.ProcesoEntrada || editedItem.ProcesoSalida"
        cols="12"
        sm="4"
        md="4"
      >
        <v-autocomplete
          v-model="editedItem.Dato"
          :items="ArrayDato"
          :item-title="(ArrayDato) => ArrayDato.Codigo + '-' + ArrayDato.Label"
          item-value="Codigo"
          color="primary"
          label="Datos: "
          dense
          hint="Digite Información"
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Naturaleza -->
      <v-col
        v-if="editedItem.ProcesoEntrada || editedItem.ProcesoSalida"
        cols="12"
        sm="4"
        md="4"
      >
        <v-autocomplete
          v-model="editedItem.Naturaleza"
          :items="ArrayNaturaleza"
          :item-title="
            (ArrayNaturaleza) => ArrayNaturaleza.Valor + '-' + ArrayNaturaleza.Descripcion
          "
          item-value="Valor"
          label="Naturaleza:"
          dense
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Esquema Asociado -->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.EsquemaAsociado"
          :items="ArraySquema"
          :item-title="(ArraySquema) => ArraySquema.Name"
          item-value="Name"
          label="Esquema Asociado:"
          dense
          clearable
          :rules="[rules.required]"
          @update:model-value="ChangeTables()"
        >
        </v-autocomplete>
      </v-col>

      <!-- Tabla Asociada -->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.TablaAsociada"
          :items="ArrayTables"
          :item-title="
            (ArrayTables) => ArrayTables.EntityName + ' (' + ArrayTables.TableName + ')'
          "
          item-value="TableName"
          color="primary"
          label="Tabla Asociada: "
          dense
          hint="Digite Información"
          :rules="[rules.required]"
          clearable
          @update:model-value="ChangeFields()"
        >
        </v-autocomplete>
      </v-col>

      <!-- Campos Asociados -->
      <v-col cols="12" sm="12" md="12">
        <v-autocomplete
          multiple
          v-model="editedItem.CampoAsociado"
          :items="ArrayFields"
          :item-title="
            (ArrayFields) =>
              ArrayFields.PropertyName + ' (' + ArrayFields.ColumnName + ')'
          "
          item-value="PropertyName"
          label="Campos Asociados:"
          dense
          clearable
          :rules="[rules.required]"
        >
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="12" md="12">
        <FilterBuilder
          :entity-fields="ArrayFields"
          :selected-field-names="editedItem.CampoAsociado"
          :field-names="editedItem.Condicion"
          @update:field-names="editedItem.Condicion = $event"
        />
      </v-col>

      <!-- Filttro -->
      <v-col cols="12" sm="12" md="12">
        <v-text-field
          v-model="editedItem.Condicion"
          label="Filtro:"
          clearable
          dense
          maxlength="1000"
          counter="1000"
          hint="Digite Información"
          readonly
        >
        </v-text-field>
      </v-col>

      <!-- Notificación 1 -->
      <v-col cols="12" sm="4" md="4">
        <v-autocomplete
          v-model="editedItem.Notificacion1"
          :items="ArraNotificacion"
          :item-title="
            (ArraNotificacion) =>
              ArraNotificacion.NotificacionId + '-' + ArraNotificacion.Descripcion
          "
          item-value="NotificacionId"
          color="primary"
          label="Notificación 1: "
          dense
          hint="Digite Información"
          :rules="[rules.required]"
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Notificación 2 -->
      <v-col cols="12" sm="4" md="4">
        <v-autocomplete
          v-model="editedItem.Notificacion2"
          :items="ArraNotificacion"
          :item-title="
            (ArraNotificacion) =>
              ArraNotificacion.NotificacionId + '-' + ArraNotificacion.Descripcion
          "
          item-value="NotificacionId"
          color="primary"
          label="Notificación 2: "
          dense
          hint="Digite Información"
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Notificación 3 -->
      <v-col cols="12" sm="4" md="4">
        <v-autocomplete
          v-model="editedItem.Notificacion3"
          :items="ArraNotificacion"
          :item-title="
            (ArraNotificacion) =>
              ArraNotificacion.NotificacionId + '-' + ArraNotificacion.Descripcion
          "
          item-value="NotificacionId"
          color="primary"
          label="Notificación 3: "
          dense
          hint="Digite Información"
          clearable
        >
        </v-autocomplete>
      </v-col>
    </v-row>
    <!--////////////////////////////////////////////// Auditoria ////////////////////////////////////////////////////////////-->
    <br />
    <v-row>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Usuario Creación: {{ editedItem.UsuarioCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Usuario Actualización: {{ editedItem.UsuarioActualizacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Creación: {{ editedItem.FechaCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Actualización: {{ editedItem.FechaActualizacion }}</span>
      </v-col>
    </v-row>
    <div align="right">
      <br />
      <v-btn size="x-large" v-if="!buttonSave" color="green" text @click="ValidateCampos">
        Guardar
      </v-btn>
    </div>
  </v-form>

  <!-- Linea de progreso -->
  <div class="d-flex align-center flex-column">
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img class="mx-auto" :width="5" src="/static/iconos/logo2.png"></v-img>
          </v-toolbar>
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {
  putUpdate,
  postInsert,
} from "@/views/TCI/Parametros/DisparadorNotificaciones/DisparadorNotificacionesService";
import {
  getSchemas,
  getTables,
  getFields,
} from "@/views/Sistema/Services/MetaDataService";
import { TablaSeleccion } from "@/views/TCI/Seguridad/Constantes/ConstantesSeguridad";
import {
  TipoDisparador,
  TipoText,
  TipoEnvio,
} from "@/views/TCI/Parametros/Constantes/ConstantesParametros";
import { getAllProcess } from "@/views/TCI/ProcesosP/Procesos/ProcesosService";
import FilterBuilder from "@/views/TCI/Parametros/DisparadorNotificaciones/FilterBuilder";

export default {
  name: "notificacion-registro",
  components: {
    FilterBuilder,
  },
  props: {
    editedIndex: {
      type: Number,
      default: 0,
      Description: "Cambia de actualización a creación o visceversa",
    },
    infoedit: {
      type: Object,
      default: [],
      Description: "Información de datos",
    },
    page: {
      type: Boolean,
      default: false,
      Description: "Saber desde donde se llama la página",
    },
    pageiframe: {
      type: Boolean,
      default: false,
      Description: "LLamado a Página Iframe",
    },
    componenteview: {
      type: Number,
      default: 0,
      Description: "Saber a que página llamar",
    },
    iconodialogbtn: {
      type: String,
      default: null,
      Description: "Información icono iframe",
    },
    titledialogbtn: {
      type: String,
      default: null,
      Description: "Información titulo iframe",
    },
    Exito: {
      type: String,
      default: null,
      Description: "Información de respuesta post o put",
    },
    userId: {
      type: String,
      default: null,
      Description: "Información de respuesta post o put",
    },
  },
  data() {
    return {
      TipoDisparador,
      TipoText,
      TipoEnvio,
      panel: [1],
      progreso: false,
      componenteview: 0,
      buttonSave: false,
      editedItem: {
        IdDisparador: 0,
        Descripcion: null,
        Tipo: null,
        Pagina: null,
        Subrutina: null,
        Evento: null,
        NombreEvento: null,
        Creacion: false,
        Modificacion: false,
        Consulta: false,
        Retiro: false,
        EsquemaAsociado: null,
        TablaAsociada: null,
        CampoAsociado: null,
        Asignacion: false,
        ProcesoEntrada: false,
        ProcesoSalida: false,
        ProcesoId: null,
        GrabaActualizaDato: false,
        Dato: null,
        Naturaleza: null,
        Condicion: null,
        Notificacion1: null,
        Notificacion2: null,
        Notificacion3: null,
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
      },
      defaultItem: {
        IdDisparador: 0,
        Descripcion: null,
        Tipo: null,
        Pagina: null,
        Subrutina: null,
        Evento: null,
        NombreEvento: null,
        Creacion: false,
        Modificacion: false,
        Consulta: false,
        Retiro: false,
        EsquemaAsociado: null,
        TablaAsociada: null,
        CampoAsociado: null,
        Asignacion: false,
        ProcesoEntrada: false,
        ProcesoSalida: false,
        ProcesoId: null,
        GrabaActualizaDato: false,
        Dato: null,
        Naturaleza: null,
        Condicion: null,
        Notificacion1: null,
        Notificacion2: null,
        Notificacion3: null,
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
      },
      ArrayProcesos: [],
      ArrayDato: [],
      ArraNotificacion: [],
      ArrayTipoDisparador: [],
      ArrayNaturaleza: [],
      ArraySquema: [],
      ArrayTables: [],
      ArrayFields: [],
      rules: {
        required: (v) => !!v || "Campo obligatorio",

        email: (v) =>
          !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || "Correo electrónico inválido",
      },
    };
  },

  methods: {
    // Convertir a numero
    isNumber: function (evt) {
      evt = evt || window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////
    // Validación de campos
    async ValidateCampos() {
      const { valid } = await this.$refs.form.validate();
      if (!valid) {
        this.$swal({
          icon: "warning",
          title: "Campos Incompletos.",
          html: " Hay campos que se encuentran incompletos.",
        });
        this.$refs.form.validate();
        return;
      }

      // Consultas a Ejecutar
      var userperfil = this.$store.getters.userperfil;
      this.editedItem.UsuarioActualizacion = userperfil.userInfo.Usuario_ID;
      this.editedItem.UsuarioCreacion = userperfil.userInfo.Usuario_ID;

      if (this.editedIndex != -1) {
        this.putRegistro();
      } else {
        this.postRegistro();
      }
    },

    // Crear Registro
    async postRegistro() {
      this.progreso = true;
      try {
        const result = await postInsert(this.editedItem);
        this.reset();
        var data = false;
        this.$emit("update:page", data);
        this.$emit("update:Exito", result);
        this.$swal({
          icon: "success",
          title: "¡Éxito!",
          html: " El registro fue guardado correctamente.",
        });
      } catch (error) {
        console.error(error);
        const registro = error.data || {};
        const mensajeerror =
          registro.Mensaje || registro.ExceptionMessage || JSON.stringify(registro);

        if (error.status === 404) {
          this.$swal({
            icon: "warning",
            title: "Consulta inexistente.",
            html: mensajeerror,
          });
        } else {
          this.$swal({
            icon: "error",
            title: "Error al consultar",
            html:
              "El servidor ha encontrado la siguiente condición inesperada:<br><small><code>" +
              mensajeerror +
              "</code></small>",
          });
        }
      } finally {
        this.progreso = false;
      }
    },

    // Actualizacion de registro
    async putRegistro() {
      this.progreso = true;
      try {
        const result = await putUpdate(this.editedItem);
        this.reset();
        var data = false;
        this.$emit("update:page", data);
        this.$emit("update:Exito", result);
        this.$swal({
          icon: "success",
          title: "¡Éxito!",
          html: " El registro fue guardado correctamente.",
        });
      } catch (error) {
        console.error(error);
        const registro = error.data || {};
        const mensajeerror =
          registro.Mensaje || registro.ExceptionMessage || JSON.stringify(registro);

        if (error.status === 404) {
          this.$swal({
            icon: "warning",
            title: "Consulta inexistente.",
            html: mensajeerror,
          });
        } else {
          this.$swal({
            icon: "error",
            title: "Error al consultar",
            html:
              "El servidor ha encontrado la siguiente condición inesperada:<br><small><code>" +
              mensajeerror +
              "</code></small>",
          });
        }
      } finally {
        this.progreso = false;
      }
    },

    // Consulta Schemas
    async getSchemas() {
      this.ArraySquema = [];
      const result = await getSchemas();
      this.ArraySquema = result;
    },

    // Consulta Tables
    async getTables(idSchema) {
      this.ArrayTables = [];
      const result = await getTables(idSchema);
      this.ArrayTables = result;
    },

    // Consulta Fields
    async getFields(idSchema, idTable) {
      this.ArrayFields = [];
      const result = await getFields(idSchema, idTable);
      this.ArrayFields = result;
    },

    // Consulta Procesos
    async getProcesos() {
      this.ArrayProcesos = [];
      const result = await getAllProcess();
      this.ArrayProcesos = result;
    },

    ///////////////////////////////////////////////// Métodos de acciones ///////////////////////////////////////////
    reset() {
      this.editedItem = Object.assign({}, this.defaultItem);
    },

    // Cambio Tipo Disparador
    ChangeTipoDisparador() {
      this.editedItem.Pagina = null;
      this.editedItem.Subrutina = null;
      this.editedItem.Evento = null;
      this.editedItem.NombreEvento = null;
    },

    // Cambio Tables
    ChangeTables() {
      this.editedItem.TablaAsociada = null;
      this.editedItem.CampoAsociado = null;
      this.getTables(this.editedItem.EsquemaAsociado);
    },

    // Cambio Fields
    ChangeFields() {
      this.editedItem.CampoAsociado = null;
      this.getFields(this.editedItem.EsquemaAsociado, this.editedItem.TablaAsociada);
    },

    // Cargue Combos
    CargueCombos() {
      var Tables = this.$store.getters.MTablaSeleccion;

      this.getSchemas();
      this.getProcesos();

      var datos = this.$store.getters.MDatos;
      this.ArrayDato = datos;

      var notificacion = this.$store.getters.MNotificacion;
      this.ArraNotificacion = notificacion;

      this.ArrayTipoDisparador = Tables.filter(
        (item) => item.Valor != null && item.TablaId == TablaSeleccion.TipoDisparador
      );

      this.ArrayNaturaleza = Tables.filter(
        (item) => item.Valor != null && item.TablaId == TablaSeleccion.Naturaleza
      );
    },

    // Actualizar carga
    ActualizarCargue() {
      if (this.editedIndex != -1) {
        // Actualizar
        this.editedItem = this.infoedit;
        this.getTables(this.editedItem.EsquemaAsociado);
        this.getFields(this.editedItem.EsquemaAsociado, this.editedItem.TablaAsociada);
      }
    },
  },
  mounted() {
    this.CargueCombos();
    this.ActualizarCargue();
  },
};
</script>
